import { useQueryClient } from '@tanstack/react-query'
import { Key } from 'react-aria'
import { Outlet, Route, Routes, useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { useDamageAnalysisAvailability } from '../api/damage-analysis'
import { useDocumentListAll } from '../api/documents'
import { Select } from '../components/select'
import { Tab } from '../components/tab'
import { IgnoreRentner } from '../ignore-rentner'

export function Root() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Main />} />
				<Route path="/create" element={<Create />} />
				<Route path="/:id/*" element={<Detail />} />
			</Routes>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}

function Main() {
	return (
		<div className="mb-6 flex gap-4 justify-between items-center">
			<h2 className="text-lg">Rezervace</h2>
			<IgnoreRentner />
		</div>
	)
}

function Create() {
	return (
		<div className="flex items-center gap-4 mb-5">
			<Link to="../">←</Link>
			<h2 className="text-lg">Nová rezervace</h2>
		</div>
	)
}

function Detail() {
	const { id } = useParams()
	const { data: documents } = useDocumentListAll()
	const queryClient = useQueryClient()

	// Tab "Vyhodnotit poškození" se zobrazí jen když oba (výdej + vratka)
	// workflow requests existují a obsahují fotky vozidla. Lehký 200 B
	// dotaz, refetchne se na window focus (kdyby pokladna mezitím
	// odeslala data v jiné záložce).
	const { data: damageAvailability } = useDamageAnalysisAvailability(id ?? '', !!id)
	const showDamageTab = !!damageAvailability?.canRun

	return (
		<>
			<div className="flex items-center gap-4 mb-5">
				<Link to="../">←</Link>
				<h2 className="text-lg">Detail rezervace</h2>
			</div>
			<div className="flex gap-4 p-4 justify-between items-center">
				<nav className="border-b border-gray-200">
					<ul className="flex -mb-px">
						<li>
							<Tab to="." end>
								Základní
							</Tab>
						</li>
						<li>
							<Tab to="payment">Přijaté příjmy</Tab>
						</li>
						<li>
							<Tab to="expense">Plánované příjmy</Tab>
						</li>
						<li>
							<Tab to="logs">Historie</Tab>
						</li>
						<li>
							<Tab to="handover-return">Výdej a vratka</Tab>
						</li>
						{showDamageTab ? (
							<li>
								<Tab to="damage">Vyhodnotit poškození</Tab>
							</li>
						) : null}
					</ul>
				</nav>
				<div className="flex gap-4 items-center">
					Vygenerovat dokument:
					<Select
						onSelectionChange={(documentId: Key) => {
							window.open(`/api/0/document/${documentId}/generate/${id}`)
							setTimeout(() => {
								queryClient.invalidateQueries({ queryKey: ['api', 'reservation'] })
							}, 2000)
						}}
						selectedKey={null}
						options={
							documents?.map(document => ({
								value: document.id,
								label: document.name,
							})) ?? []
						}
					/>
				</div>
			</div>
		</>
	)
}
